import React from 'react'

const CalenderIcon = ({width=10, height=12, fill="#CE181E" }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 10 12" fill={fill} xmlns="http://www.w3.org/2000/svg">
<path d="M9 1.5H8.5V0.5H7.5V1.5H2.5V0.5H1.5V1.5H1C0.45 1.5 0 1.95 0 2.5V10.5C0 11.05 0.45 11.5 1 11.5H9C9.55 11.5 10 11.05 10 10.5V2.5C10 1.95 9.55 1.5 9 1.5ZM9 10.5H1V4H9V10.5Z" fill={fill}/>
</svg>

  )
}

export default CalenderIcon